import { ModalProps } from "./types";
import "./styles.scss";

const Modal: React.FC<ModalProps> = ({ isOpen, className, children }) => {
  if (!isOpen) return null;

  return (
    <div
      data-testid="modal"
      className={`modal__wrapper ${className}`}>
      <div className="modal__content">{children}</div>
    </div>
  );
};

export default Modal;
